// components/BookTailorInfoSmall.jsx
import { useTranslations } from 'next-intl';
import Image from "next/image";

const BookTailorInfoSmall = () => {
  const t = useTranslations('bookTailorInfo');

  return (
    <div className="max-w-[740px] w-full mx-auto px-5">
      <div className="flex items-center space-x-3 justify-center md:justify-start">
        <div className="w-8 h-8 relative">
          <Image
            src="/images/logo-circle.svg"
            alt="Book Tailor Logo"
            fill
            style={{ objectFit: 'contain' }}
          />
        </div>
        <div className="text-[#2b2b2b] font-inter text-[11px]">
          <p className="font-semibold">{t('companyName')}</p>
          <p>{t('locatedAt')}</p>
        </div>
      </div>
    </div>
  );
};

export default BookTailorInfoSmall;